module.exports = __webpack_public_path__ + "img/ecommerce.category.content_image_21.7a216e02.webp";